<template>
  <div class="category-selector">
    <template v-for="category in categories">
      <category-button
          :key="category.id"
          :value="categoryEnabled(category)"
          @input="updateCategory(category, $event)"
      >
        {{ category.name }}
      </category-button>
      <category-selector v-if="category.children && category.children.length > 0"
                         class=""
                         :categories="category.children"
                         :value="value"
                         @input="$emit('input',$event)"
      />
    </template>
  </div>
</template>

<script>
import CategoryButton from "@/components/CategoryButton";

export default {
  name: "CategorySelector",
  components: {CategoryButton},
  props: {
    categories: {type: Array, default: () => []},
    value: {type: Array, default: () => []},
  },
  methods: {
    categoryEnabled(cat) {
      return !!this.value.find(el => el.id === cat.id)
    },
    updateCategory(category, enable) {
      if (enable) {
        this.$emit('input', [
          ...this.value,
          ...[category]
        ])
      } else {
        let index = this.value.findIndex(el => el.id === category.id)
        if (index > -1) {
          let cats = this.value.slice();
          cats.splice(index, 1)
          this.$emit('input', cats)
        } else {
          console.log('cat not found')
        }

      }
    },
    // updateCategoryChildren(parent, children) {
    //   console.log('updateCategoryChildren', parent, children)
    //   parent.children = children
    //
    //   let parentIdx = this.value.findIndex(el => el.id === parent.id);
    //   console.log('parentIdx', parentIdx)
    //   if (parentIdx > -1) {
    //     let newValue = [...this.value];
    //     console.log('newValue', newValue)
    //
    //     newValue.splice(parentIdx, 1, parent);
    //     console.log('newValue updated', newValue)
    //     this.$emit('input', newValue);
    //   } else {
    //     console.log('parent not found')
    //     this.$emit('input', [
    //       ...this.value,
    //       ...[parent]
    //     ])
    //   }
    //
    //
    // }
  }
}
</script>

<style scoped>

</style>
